import React from "react";

export default function Hr() {
  return <div className="w-full h-1  bg-gradient-to-r from-[#22c55e] "></div>;
}
